// @flow
import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import SliderWithInput from 'live/components/forms/ui/slider-with-input'
import { ConfigSubtitle } from 'plugin-assets/shared/widget/components/styled'

const fitToHeight = 'fitToHeight'
const fitToHeightAndWidth = 'fitToHeightAndWidth'

export default class ResizeConfig extends React.Component<ConfigProps> {
    changeMaxHeight = (value: number) => this.props.changeLayoutConfig('maxHeight', value)
    changeResize = (value: string) => this.props.changeLayoutConfig('resizing', value)
    setFitToHeightAndWidth = () => this.changeResize(fitToHeightAndWidth)
    setFitToHeight = () => this.changeResize(fitToHeight)

    render() {
        const config = this.props.config
        const value = parseInt(config.maxHeight)
        const maxHeightDisabled = config.resizing !== fitToHeight

        return (
            <ResizeConfigContainer>
                <div>
                    <ConfigSubtitle>{i18n('Resizing')}</ConfigSubtitle>
                    <div className="flex">
                        <ResizeIconLarge>
                            <i className="far fa-arrow-to-top" />
                            <div
                                className={
                                    'flex flex-row flex-center-items ' +
                                    (config.resizing === fitToHeight ? 'flex-center' : 'flex-space-between')
                                }
                            >
                                {config.resizing === fitToHeight ? null : <i className="far fa-arrow-to-left" />}
                                <span>aA</span>
                                {config.resizing === fitToHeight ? null : <i className="far fa-arrow-to-right" />}
                            </div>
                            <i className="far fa-arrow-to-bottom" />
                        </ResizeIconLarge>
                        <div className="flex flex-column flex-space-between">
                            <ResizeOption className="flex flex-center-items" onClick={this.setFitToHeightAndWidth}>
                                <input
                                    readOnly
                                    value={fitToHeightAndWidth}
                                    checked={config.resizing === fitToHeightAndWidth}
                                    type="radio"
                                />
                                <ResizeIconSmall selected={config.resizing === fitToHeightAndWidth}>
                                    <i className="far fa-arrow-to-top" />
                                    <div className="flex flex-row flex-center-items flex-space-between">
                                        <i className="far fa-arrow-to-left" />
                                        <span>aA</span>
                                        <i className="far fa-arrow-to-right" />
                                    </div>
                                    <i className="far fa-arrow-to-bottom" />
                                </ResizeIconSmall>
                                {i18n('Adjust to fit')}
                            </ResizeOption>
                            <ResizeOption className="flex flex-center-items" onClick={this.setFitToHeight}>
                                <input
                                    readOnly
                                    value={fitToHeight}
                                    checked={config.resizing === fitToHeight}
                                    type="radio"
                                />
                                <ResizeIconSmall selected={config.resizing === fitToHeight}>
                                    <i className="far fa-arrow-to-top" />
                                    <div className="flex flex-row flex-center-items flex-center">
                                        <span>aA</span>
                                    </div>
                                    <i className="far fa-arrow-to-bottom" />
                                </ResizeIconSmall>
                                {i18n('Fit to max height')}
                            </ResizeOption>
                        </div>
                    </div>
                    {maxHeightDisabled ? null : (
                        <MaxHeightConfig disabled={maxHeightDisabled}>
                            <ConfigSubtitle>{i18n('Max height')}</ConfigSubtitle>
                            <SliderWithInput
                                defaultValue={value || 100}
                                min={10}
                                max={100}
                                stepSlider={10}
                                stepInput={1}
                                onChange={this.changeMaxHeight}
                                disabled={maxHeightDisabled}
                            />
                        </MaxHeightConfig>
                    )}
                </div>
            </ResizeConfigContainer>
        )
    }
}

const ResizeOption = styled.div`
    cursor: pointer;
`

const ResizeIconSmall = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    text-align: center;
    width: 60px;
    height: 60px;
    padding: 7px 7px;
    margin: 0px 8px 5px 5px;
    border: ${props => (props.selected ? 'solid' : 'dashed')} 1px
        ${props =>
            props.selected ? props.theme['link-button'] : props.theme.ResizeIconSmall || props.theme['input-borders']};
    font-size: 8px;
    span {
        font-size: 10px;
        font-family: ${({ theme }) => theme['font-semibold']};
    }
`

const ResizeIconLarge = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    text-align: center;
    padding: 10px 10px;
    width: 92px;
    height: 92px;
    border: solid 1px ${({ theme }) => theme['link-button']};
    margin-right: 6px;
    font-size: 14px;
    margin-top: 18px;
    margin-bottom: 18px;
    span {
        font-size: 18px;
        font-family: ${({ theme }) => theme['font-semibold']};
    }
`

const MaxHeightConfig = styled.div`
    margin-top: 17px;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
`
const ResizeConfigContainer = styled.div`
    padding: 0px 13px;
    margin-bottom: 17px;
`
